export default {
  editMode: {
    title: 'Who would you like to assign this deposit to?',
    subtitle:
      'Please select a user from the list below, choose a contribution type, and specify the estimated cost basis (if known).',
    buttonCancel: 'Cancel',
    buttonNext: 'Next',
  },
  viewMode: {
    general: {
      title: 'Submit the deposit',
      subtitle:
        'You are about to submit a deposit. Please review the details carefully before proceeding.',
      buttonReturn: 'Return',
      buttonSubmit: 'Submit',
    },
    warning: {
      title: 'Active pre-notify deposit!',
      subtitle:
        'has an active pre-notify deposit. Please confirm that you’ve selected the correct user and want to submit the deposit.',
      buttonSubmit: 'Confirm and submit',
    },
  },
  placeholder: {
    transferId: 'Transfer ID',
    contributionType: 'Contribution type',
    user: 'User',
    amount: 'Amount',
    fiatEquivalent: 'Est. cost basis',
  },
  confirmationMessage: 'The deposit has been successfully assigned',
  warningMessage: 'Active pre-notify deposit! Please confirm before proceeding.',
};
